export const menuData = [
    {
        label: 'Home',
        url: 'https://www.rainerb.ml',
    },
    {
        label: 'About',
        url: 'https://www.rainerb.ml/#/about',
    },
    {
        label: 'BandCamp',
        url: 'https://klvsmusic.bandcamp.com',
    },
    {
        label: 'OBSKUR MUSIC (Label)',
        url: 'https://www.obskurmusic.co'
    }
];